module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_accessories-7fd43c3daba2971c708600c07fa089d9.png";